<template>
    <ul class="pagination">
        <li class="page-item" :class="(this.currGroup == 1) ? 'disabled' : ''">
            <a class="page-link page-link--with-arrow" href="" aria-label="Previous"  @click.prevent="decreaseGroupPage">
                <span class="page-link__arrow page-link__arrow--left" aria-hidden="true"><svg width="7" height="11">
                        <path d="M6.7,0.3L6.7,0.3c-0.4-0.4-0.9-0.4-1.3,0L0,5.5l5.4,5.2c0.4,0.4,0.9,0.3,1.3,0l0,0c0.4-0.4,0.4-1,0-1.3l-4-3.9l4-3.9C7.1,1.2,7.1,0.6,6.7,0.3z" />
                    </svg>
                </span>
            </a>
        </li>
        <!-- <li class="page-item" >
            <a class="page-link page-link--with-arrow" href="#" aria-label="Previous" v-if="page != 1" @click.prevent="updatPage(page, 'less')">
                <span class="page-link__arrow page-link__arrow--left" aria-hidden="true" >
                    <svg width="7" height="11">
                        <path d="M6.7,0.3L6.7,0.3c-0.4-0.4-0.9-0.4-1.3,0L0,5.5l5.4,5.2c0.4,0.4,0.9,0.3,1.3,0l0,0c0.4-0.4,0.4-1,0-1.3l-4-3.9l4-3.9C7.1,1.2,7.1,0.6,6.7,0.3z"></path>
                    </svg>
                </span>
            </a>
        </li> -->
        <li class="page-item" v-for="pageNumber in groupPage" :key="pageNumber.pageNumber" :class="[this.page === pageNumber ? 'active' : '']"> 
            <a class="page-link" href="#"  @click.prevent="updatPage(pageNumber)">
                {{pageNumber}}
                <span class="sr-only" v-if="this.page === pageNumber">(current)</span>
            </a>
        </li>
        <li class="page-item page-item--dots" v-if="this.pages.length > 10">
            <div class="pagination__dots"></div>
        </li>
        <!-- last page number -->
        <li class="page-item" v-if="this.pages.length > 10" :class="[this.page === this.pages.length ? 'active' : '']">
            <a class="page-link" href="#" @click.prevent="updatPage(this.pages.length)">
                {{this.pages.length}}
            </a>
        </li>
        <li class="page-item" v-if="this.pages.length > 10">
            <a v-if="page < pages.length" class="page-link page-link--with-arrow" href="#" aria-label="Next" @click.prevent="increaseGroupPage">
                <span class="page-link__arrow page-link__arrow--right" aria-hidden="true">
                    <svg width="7" height="11">
                        <path d="M0.3,10.7L0.3,10.7c0.4,0.4,0.9,0.4,1.3,0L7,5.5L1.6,0.3C1.2-0.1,0.7,0,0.3,0.3l0,0c-0.4,0.4-0.4,1,0,1.3l4,3.9l-4,3.9C-0.1,9.8-0.1,10.4,0.3,10.7z"></path>
                    </svg>
                </span>
            </a>
        </li>
    </ul>
</template>

<script>
export default {
    props: {
        perPage : {
            type: Number,
            required: true,
        },

        pages: {
            type: Array,
            require: false,
        }
    },

    data() {
        return {
            page : 1,
            currGroup: 1,
        }
    },

    computed: {
        groupPage() {
            let pages = this.pages;
            let newpages = [];
            if(pages.length > 9){
                newpages = this.pages;
                let gp = 1;
                while(gp <= this.currGroup){
                    if (gp == 1){
                        newpages = pages.slice().splice(0, 10);   
                    }else{
                        let spliced = (gp - 1) * 10;
                        newpages = pages.slice().splice(spliced, 10);
                    }
                    gp++;
                }
                pages = newpages;
            }
            return pages;
        }
    },

    watch: {
        currGroup(newVal){
            // get the first page of the group page
            const currentPage = (newVal * 10)  -  9;
            this.updatPage(currentPage);
        }
    },

    methods: {
        updatPage(currentPage, action = null){
            switch(action){
                case 'less':
                    this.page--;
                break;
                case 'add':
                    this.page++;
                break;
                default: 
                    this.page = currentPage;
                break;
            }
            
            this.$emit('updatePage', this.page);
        },

        decreaseGroupPage(){
            this.currGroup -= 1;
        },

        increaseGroupPage(){
            this.currGroup += 1;   
        },

        setPage(newPage){
            this.page = newPage;
        }
    },

    updated() {
    },
}
</script>